let copies = {
  NOTFOUND_TITLE: {
    es: '¡Oops!',
    pt: 'Ops!'
  },
  NOTFOUND_1: {
    es: 'No podemos encontrar la página a la que quieres acceder.',
    pt: 'Não conseguimos encontrar a página que você deseja acessar.'
  },
  NOTFOUND_2: {
    es: 'Revisa la dirección introducida o ve a alguna de las secciones disponibles en el menú.',
    pt: 'Verifique o endereço inserido ou vá para uma das seções disponíveis no menu.'
  },
  LOGIN_WELCOME_TITLE: {
    es: '¡Hola de nuevo!',
    pt: 'Olá novamente!'
  },
  LOGIN_WELCOME_SUBTITLE: {
    es: 'Accede a tu cuenta',
    pt: 'Acesse sua conta'
  },
  LOGIN_EMAIL_PLACEHOLDER: {
    es: 'Email de usuario',
    pt: 'Email do utilizador'
  },
  LOGIN_PASSWORD_PLACEHOLDER: {
    es: 'Contraseña',
    pt: 'Password'
  },
  LOGIN_REPEAT_PASSWORD_PLACEHOLDER: {
    es: 'Repetir contraseña',
    pt: 'Repetir a password'
  },
  LOGIN_CODE_PLACEHOLDER: {
    es: 'Código',
    pt: 'Código'
  },
  LOGIN_BUTTON: {
    es: 'Acceder',
    pt: 'Acessar'
  },
  LOGIN_TFA_TITLE: {
    es: 'Verificación de doble factor',
    pt: 'Verificação de dois fatores'
  },
  LOGIN_TFA_SUBTITLE: {
    es: 'Introducce aquí el código recibido por email:',
    pt: 'Insira aqui o código recebido por e-mail:'
  },
  LOGIN_TFA_BUTTON: {
    es: 'Aceptar',
    pt: 'Aceitar'
  },
  LOGIN_CREATE_PW_TITLE: {
    es: 'Crear contraseña',
    pt: 'Criar senha'
  },
  LOGIN_CREATE_PW_SUBTITLE_1: {
    es: 'Debe de crear una contraseña ya que es la primera vez que accede o por que se ha caducado la que tenía establecida.',
    pt: 'Você deve criar uma senha porque é a primeira vez que acessa ou porque a anterior expirou.'
  },
  LOGIN_CREATE_PW_SUBTITLE_2: {
    es: 'La contraseña debe contener al menos una minúscula, una mayúscula, un número y un carácter especial, y debe estar compuesta por al menos 10 caracteres.',
    pt: 'A senha deve conter pelo menos uma letra minúscula, uma letra maiúscula, um número e um caractere especial, e deve ter pelo menos 10 caracteres.'
  },
  LOGIN_CREATE_PW_DIFF_ERROR: {
    es: 'Las contraseñas no coinciden.',
    pt: 'As senhas não coincidem.'
  },
  LOGIN_CREATE_PW_REQ_ERROR: {
    es: 'La contraseña no cumple los requisitos mínimos.',
    pt: 'A senha não atende aos requisitos mínimos.'
  },
  LOGIN_CREATE_PW_BUTTON: {
    es: 'Cambiar',
    pt: 'Alterar'
  },
  LOGIN_USER_BLOCKED_ERROR: {
    es: 'El usuario con el que intenta acceder está bloqueado. Contacte con su administrador para más información.',
    pt: 'O usuário que você está tentando acessar está bloqueado. Contate seu administrador para mais informações.'
  },
  LOGIN_NO_VALID_EMAIL_ERROR: {
    es: 'Este email está asociado a más de una cuenta. Por favor, acceda con un alias.',
    pt: 'Este e-mail está associado a mais de uma conta. Por favor, acesse com um alias.'
  },
  LOGIN_CODE_INVALID_ERROR: {
    es: 'El código introducido no es correcto.',
    pt: 'O código inserido está incorreto.'
  },
  LOGIN_CODE_TIME_OUT_ERROR: {
    es: 'El código ha caducado.',
    pt: 'O código expirou.'
  },
  LOGIN_LAST_LOGIN_DIALOG_1: {
    es: 'Su última conexión: ',
    pt: 'A sua última ligação '
  },
  LOGIN_LAST_LOGIN_DIALOG_2: {
    es: 'Información en materia de seguridad:',
    pt: 'Informações de segurança:'
  },
  LOGIN_LAST_LOGIN_DIALOG_3: {
    es: 'Está usted accediendo a un sistema de tratamiento de la información propiedad de BOTS FACTORY S.L. El acceso y uso de este sistema está permitido exclusivamente a las personas autorizadas y para fines estrictamente profesionales. La información a la que se accede por este medio es propiedad de BOTS FACTORY S.L y está sujeta a las obligaciones de confidencialidad y seguridad establecidas en las políticas y normativas de seguridad de la organización.',
    pt: 'Está a aceder a um sistema de processamento de informações propriedade da BOTS FACTORY S.L. O acesso e a utilização deste sistema são permitidos exclusivamente a pessoas autorizadas e para fins estritamente profissionais. A informação a que se acede por este meio é propriedade da BOTS FACTORY S.L. e está sujeita às obrigações de confidencialidade e segurança estabelecidas nas políticas e normas de segurança da organização.'
  },
  LOGIN_LAST_LOGIN_DIALOG_4: {
    es: 'El usuario se compromete a guardar el más absoluto secreto respecto de toda la información a la que tenga acceso a través de la aplicación y en particular, se obliga a no utilizarla con fines distintos a los que se les ha autorizado expresamente.',
    pt: 'O utilizador compromete-se a manter estritamente secretas todas as informações a que tem acesso através da aplicação e, em particular, compromete-se a não as utilizar para fins diferentes daqueles para os quais foi expressamente autorizado.'
  },
  LOGIN_LAST_LOGIN_DIALOG_5: {
    es: 'BOTS FACTORY S.L. podrá proceder a inspeccionar el contenido de los sistemas de información, y/o la configuración establecida en los mismos, para garantizar el correcto ejercicio de las funciones y competencias de la entidad, así como monitorizar el uso de las aplicaciones, servicios e información.',
    pt: 'A BOTS FACTORY S.L. poderá proceder à inspeção do conteúdo dos sistemas de informação, e/ou da configuração estabelecida nos mesmos, com o fim de garantir o correto exercício das funções e competências da entidade, assim como para controlar a utilização das aplicações, serviços e informação.'
  },
  CLIENTS_CHATBOTS_BREADCRUMB: {
    es: 'Chatbots',
    pt: 'Chatbots'
  },
  CLIENTS_NEW_CHATBOT: {
    es: 'Nuevo Chatbot',
    pt: 'Novo Chatbot'
  },
  CLIENTS_CLI_NAME: {
    es: 'Nombre',
    pt: 'Nome'
  },
  CLIENTS_CLI_DESCRIPTION: {
    es: 'Descripción',
    pt: 'Descrição'
  },
  CLIENTS_CLI_DEL_DIALOG: {
    es: 'Estás seguro de borrar el cliente',
    pt: 'Tem certeza de que deseja excluir o cliente?'
  },
  WIDGETCODE_COMMON_CSS: {
    es: '1. CSS común (Insertar en "Head")',
    pt: '1. CSS comum (Inserir em "Head")'
  },
  WIDGETCODE_COPY_TO_CLIPBOARD: {
    es: 'Copiado al portapapeles',
    pt: 'Copiado para a área de transferência'
  },
  WIDGETCODE_COPY: {
    es: 'Copiar',
    pt: 'Copiar'
  },
  WIDGETCODE_HTML_CODE: {
    es: '2. Código HTML',
    pt: '2. Código HTML'
  },
  WIDGETCODE_PAGE_SCRIPT: {
    es: '3. Script para la página (Insertar en "Body")',
    pt: '3. Script para a página (Inserir em "Body")'
  },
  WIDGETCODE_FULL_SCREEN: {
    es: 'Pantalla completa',
    pt: 'Tela completa'
  },
  WIDGETCODE_FONT_SIZE: {
    es: 'Tamaño letra:',
    pt: 'Tamanho de letra:'
  },
  WIDGETCODE_HIGH_CONTRAST: {
    es: 'Alto contraste:',
    pt: 'Alto contraste:'
  },
  WIDGETCODE_DELETE_CHAT: {
    es: 'Eliminar conversación',
    pt: 'Apagar conversa'
  },
  CREATEWIDGET_BREADCRUMB: {
    es: 'Creación del Widget',
    pt: 'Criação do Widget'
  },
  CREATEWIDGET_FORM_LABEL: {
    es: 'Aspecto del chat',
    pt: 'Aparência do chat'
  },
  CREATEWIDGET_FORM_BACKGROUND: {
    es: 'Fondo:',
    pt: 'Fundo:'
  },
  CREATEWIDGET_FORM_BOT_BACKGROUND: {
    es: 'Fondo del bocadillo del bot:',
    pt: 'Fundo do balão do bot:'
  },
  CREATEWIDGET_FORM_USER_BACKGROUND: {
    es: 'Fondo del bocadillo del usuario:',
    pt: 'Fundo do balão do usuário:'
  },
  CREATEWIDGET_FORM_BOT_TEXT_COLOR: {
    es: 'Color de texto del bot:',
    pt: 'Cor do texto do bot:'
  },
  CREATEWIDGET_FORM_BOT_LINK_COLOR: {
    es: 'Color de los links por parte del bot:',
    pt: 'Cor dos links do bot:'
  },
  CREATEWIDGET_FORM_USER_TEXT_COLOR: {
    es: 'Color de texto del usuario:',
    pt: 'Cor do texto do usuário:'
  },
  CREATEWIDGET_FORM_HEADER_BACKGROUND: {
    es: 'Fondo del encabezado:',
    pt: 'Fundo do cabeçalho:'
  },
  CREATEWIDGET_FORM_HEADER_TEXT_COLOR: {
    es: 'Color de texto del encabezado:',
    pt: 'Cor do texto do cabeçalho:'
  },
  CREATEWIDGET_FORM_SEND_MSG_SECTION_BACKGROUND: {
    es: 'Fondo de la sección de envío de mensaje:',
    pt: 'Fundo da seção de envio de mensagem:'
  },
  CREATEWIDGET_FORM_INPUT_TEXT_COLOR: {
    es: 'Color de texto del input de mensaje:',
    pt: 'Cor do texto do campo de mensagem:'
  },
  CREATEWIDGET_FORM_INPUT_BORDER_COLOR: {
    es: 'Color del borde del input de mensaje:',
    pt: 'Cor da borda do campo de mensagem:'
  },
  CREATEWIDGET_FORM_SEND_BUTTON_COLOR: {
    es: 'Color del botón de enviar mensaje:',
    pt: 'Cor do botão de enviar mensagem:'
  },
  CREATEWIDGET_FORM_SEND_BUTTON_BORDER_AND_TEXT_COLOR: {
    es: 'Color del borde y texto de botón',
    pt: 'Cor da borda e do texto do botão'
  },
  CREATEWIDGET_FORM_AVATAR_URL: {
    es: 'URL del avatar:',
    pt: 'URL do avatar:'
  },
  'CREATEWIDGET_FORM_SHOW_ICON_BORDER_?': {
    es: '¿Desea establecer un color de borde en el icono?',
    pt: 'Deseja definir uma cor de borda no ícone?'
  },
  CREATEWIDGET_FORM_SHOW_ICON_BORDER_YES: {
    es: 'Sí',
    pt: 'Sim'
  },
  CREATEWIDGET_FORM_SHOW_ICON_BORDER_NO: {
    es: 'No',
    pt: 'Não'
  },
  CREATEWIDGET_FORM_ICON_BORDER_COLOR: {
    es: 'Color del borde del icono',
    pt: 'Cor da borda do ícone'
  },
  CREATEWIDGET_FORM_BOT_TITLE: {
    es: 'Título bot:',
    pt: 'Título do bot:'
  },
  CREATEWIDGET_FORM_BOT_SUBTITLE: {
    es: 'Subtitulo bot:',
    pt: 'Subtítulo do bot:'
  },
  CREATEWIDGET_FORM_BOT_INITIAL_MSG: {
    es: 'Mensaje inicial del bot',
    pt: 'Mensagem inicial do bot'
  },
  CREATEWIDGET_FORM_USER_INITIAL_MSG: {
    es: 'Mensaje inicial del usuario',
    pt: 'Mensagem inicial do usuário'
  },
  CREATEWIDGET_FORM_INPUT_PLACEHOLDER: {
    es: 'Texto placeholder input:',
    pt: 'Texto do placeholder do campo:'
  },
  CREATEWIDGET_FORM_ALERT_BACKGROUND_COLOR: {
    es: 'Color de fondo del bocadillo de aviso',
    pt: 'Cor de fundo do balão de aviso'
  },
  CREATEWIDGET_FORM_ALERT_TEXT_COLOR: {
    es: 'Color de texto del bocadillo de aviso',
    pt: 'Cor do texto do balão de aviso'
  },
  CREATEWIDGET_FORM_ALERT_TEXT: {
    es: 'Texto del bocadillo de aviso',
    pt: 'Texto do balão de aviso'
  },
  CREATEWIDGET_FORM_SAVE_BUTTON: {
    es: 'Guardar',
    pt: 'Salvar'
  },
  CREATEWIDGET_CHATSUBMENU_FULL_SCREEN: {
    es: 'Pantalla completa',
    pt: 'Tela cheia'
  },
  CREATEWIDGET_CHATSUBMENU_FONT_SIZE: {
    es: 'Tamaño letra: ',
    pt: 'Tamanho da fonte: '
  },
  CREATEWIDGET_CHATSUBMENU_HIGH_CONTRAST: {
    es: 'Alto contraste: ON | OFF',
    pt: 'Alto contraste: ON | OFF'
  },
  CREATEWIDGET_CHATSUBMENU_DELETE_CHAT: {
    es: 'Eliminar conversación',
    pt: 'Excluir conversa'
  },
  CREATEWIDGET_USER_INFO_BOX: {
    es: 'Hola, ¿En que puedo ayudarte?',
    pt: 'Olá, em que posso ajudá-lo?'
  },
  CREATEWIDGET_BOT_INFO_BOX: {
    es: 'Hola, soy el asistente virtual. ¿En qué puedo ayudarte?',
    pt: 'Olá, sou a assistente virtual, como posso ajudá-la?'
  },
  USERS_BREADCRUMB: {
    es: 'Contactos',
    pt: 'Contatos'
  },
  USERS_ORDER_BY: {
    es: 'Ordenado por:',
    pt: 'Ordenar por:'
  },
  USERS_TOTAL: {
    es: '# Total:',
    pt: '# Total:'
  },
  USERS_FILTERS: {
    es: '# Filtros:',
    pt: '# Filtros:'
  },
  USERS_SINGLE_SELECTION: {
    es: '# Selección individual:',
    pt: '# Seleção individual:'
  },
  USERS_DOWNLOAD_MODELS: {
    es: 'Descarga modelos',
    pt: 'Baixar modelos'
  },
  USERS_BROADCAST_MSG: {
    es: 'Mensaje en Broadcast',
    pt: 'Mensagem em Broadcast'
  },
  USERS_FIND_MATCHES_PLACEHOLDER: {
    es: 'Buscar Coincidencias (Esc para cancelar)',
    pt: 'Buscar correspondências (Esc para cancelar)'
  },
  USERS_TABLE_HEADER: {
    es: 'Acciones',
    pt: 'Ações'
  },
  USERS_SEE_CHAT: {
    es: 'Ver Conversación',
    pt: 'Ver Conversa'
  },
  USERS_SELECT: {
    es: 'Seleccionar',
    pt: 'Selecionar'
  },
  USERS_UNSELECT: {
    es: 'Deseleccionar',
    pt: 'Desselecionar'
  },
  USERS_DELETE: {
    es: 'Eliminar',
    pt: 'Excluir'
  },
  USERS_NO_ASSOCIATED_USERS: {
    es: 'Este bot no tiene contactos asociados.',
    pt: 'Este bot não tem contatos associados.'
  },
  USERS_SEE_MORE: {
    es: 'Ver más',
    pt: 'Ver mais'
  },
  USERS_LOADING_CONTACTS: {
    es: 'CARGANDO CONTACTOS: ¡Paciencia! Este proceso puede demorares hasta 1 minuto dependiendo de la cantidad de contactos del sistema.',
    pt: 'CARREGANDO CONTATOS: Paciência! Este processo pode demorar até 1 minuto dependendo da quantidade de contatos do sistema.'
  },
  USERS_NO_CHATS: {
    es: 'Este usuario no tiene ninguna conversación iniciada',
    pt: 'Este usuário não tem nenhuma conversa iniciada'
  },
  USERS_SELECT_SAME_PLATFORM_CONTACTS_ALERT: {
    es: 'Debe seleccionar contactos de la misma plataforma',
    pt: 'Você deve selecionar contatos da mesma plataforma'
  },
  'USERS_DELETE_?': {
    es: '¿Desea eliminar el usuario?',
    pt: 'Deseja excluir o usuário?'
  },
  ADDKEYWORDS_BREADCRUMB_TRAINING: {
    es: 'Entrenamiento',
    pt: 'Treinamento'
  },
  ADDKEYWORDS_BREADCRUMB_ADD_KEYWORDS: {
    es: 'Añadir Keywords',
    pt: 'Adicionar Keywords'
  },
  ADDKEYWORDS_FIELD_PHRASE: {
    es: 'Frase',
    pt: 'Frase'
  },
  ADDKEYWORDS_FIELD_PHRASE_PLACEHOLDER: {
    es: 'Frase',
    pt: 'Frase'
  },
  ADDKEYWORDS_FIELD_KEYWORDS: {
    es: 'Keywords',
    pt: 'Keywords'
  },
  ADDKEYWORDS_FIELD_KEYWORDS_PLACEHOLDER: {
    es: 'Keywords separadas por comas',
    pt: 'Keywords separadas por vírgulas'
  },
  ADDKEYWORDS_FIELD_NEW_KEYWORDS: {
    es: 'New keywords',
    pt: 'Novas keywords'
  },
  ADDKEYWORDS_FIELD_NEW_KEYWORD_PLACEHOLDER: {
    es: 'Keywords separadas por comas',
    pt: 'Keywords separadas por vírgulas'
  },
  ADDKEYWORDS_FIELD_PRIORITY: {
    es: 'Prioridad',
    pt: 'Prioridade'
  },
  ADDKEYWORDS_FIELD_PRIORITY_PLACEHOLDER: {
    es: 'Prioridad',
    pt: 'Prioridade'
  },
  ADDKEYWORDS_FIELD_LANGUAGE: {
    es: 'Idioma',
    pt: 'Idioma'
  },
  ADDKEYWORDS_FIELD_END_BOT: {
    es: 'Finaliza el Bot',
    pt: 'Finaliza o Bot'
  },
  ADDKEYWORDS_FIELD_END_BOT_NO: {
    es: 'No',
    pt: 'Não'
  },
  ADDKEYWORDS_FIELD_END_BOT_YES: {
    es: 'Sí',
    pt: 'Sim'
  },
  ADDKEYWORDS_FIELD_SAVE: {
    es: 'Guardar',
    pt: 'Salvar'
  },
  TRAINING_BREADCRUMBS_TRAINING: {
    es: 'Entrenamiento',
    pt: 'Treinamento'
  },
  TRAINING_FIELDS_TYPE: {
    es: 'Tipo',
    pt: 'Tipo'
  },
  TRAINING_FIELDS_REVISED: {
    es: 'Revisado',
    pt: 'Revisado'
  },
  TRAINING_FIELDS_REVISED_ALL: {
    es: 'Todos',
    pt: 'Todos'
  },
  TRAINING_FIELDS_REVISED_NO: {
    es: 'No',
    pt: 'Não'
  },
  TRAINING_FIELDS_REVISED_YES: {
    es: 'Sí',
    pt: 'Sim'
  },
  TRAINING_UPDATE_BUTTON: {
    es: 'Actualizar',
    pt: 'Atualizar'
  },
  TRAINING_UPDATE_REVIEW: {
    es: 'Revisar',
    pt: 'Revisar'
  },
  TRAINING_SEARCH_MSG_PLACEHOLDER: {
    es: 'Buscar Mensaje (Esc para cancelar)',
    pt: 'Buscar Mensagem (Esc para cancelar)'
  },
  TRAINING_TABLE_HEADER_SELECT_INPUT: {
    es: 'Seleccionar',
    pt: 'Selecionar'
  },
  TRAINING_TABLE_HEADER_TYPE: {
    es: 'Tipo',
    pt: 'Tipo'
  },
  TRAINING_TABLE_HEADER_CHATBOT: {
    es: 'Chatbot',
    pt: 'Chatbot'
  },
  TRAINING_TABLE_HEADER_NAME: {
    es: 'Nombre',
    pt: 'Nome'
  },
  TRAINING_TABLE_HEADER_INTENT: {
    es: 'Intención',
    pt: 'Intenção'
  },
  TRAINING_TABLE_HEADER_PHRASE: {
    es: 'Frase',
    pt: 'Frase'
  },
  TRAINING_TABLE_HEADER_MSG: {
    es: 'Mensaje',
    pt: 'Mensagem'
  },
  TRAINING_TABLE_HEADER_REVIEWED: {
    es: 'Revisado',
    pt: 'Revisado'
  },
  TRAINING_TABLE_HEADER_DATE: {
    es: 'Fecha',
    pt: 'Data'
  },
  TRAINING_TABLE_BODY_SELECT: {
    es: 'Seleccionar',
    pt: 'Selecionar'
  },
  TRAINING_TABLE_BODY_UNSELECT: {
    es: 'Deseleccionar',
    pt: 'Desselecionar'
  },
  TRAINING_TABLE_BODY_ADD_KEYWORD: {
    es: 'Añadir Keywords',
    pt: 'Adicionar Keywords'
  },
  TRAINING_TABLE_BODY_REVIEW: {
    es: 'Revisar',
    pt: 'Revisar'
  },
  TRAINING_LINK_PREVIOUS_PAGE: {
    es: 'Anterior',
    pt: 'Anterior'
  },
  TRAINING_LINK_NEXT_PAGE: {
    es: 'Siguiente',
    pt: 'Próximo'
  },
  TRAINING_MARK_PHRASE_AS_REVIEWED: {
    es: '¿Desea indicar que ha revisado la frase?',
    pt: 'Deseja indicar que revisou a frase?'
  },
  TRAINING_REVIEW: {
    es: 'Revisar',
    pt: 'Revisar'
  },
  TRAINING_DISCARD: {
    es: 'Descartar',
    pt: 'Descartar'
  },
  TRAINING_DISCARD_OR_REVIEW_PHRASE: {
    es: '¿Desea descartar o revisar las frases marcadas?',
    pt: 'Deseja descartar ou revisar as frases marcadas?'
  },
  BUTTONS_PAYLOAD: {
    es: 'Payload (Campo obligatorio)',
    pt: 'Payload (Campo obrigatório)'
  },
  BUTTONS_TEXT: {
    es: 'Texto botón (Campo obligatorio)',
    pt: 'Texto do botão (Campo obrigatório)'
  },
  BUTTON_KEYWORDS: {
    es: 'Keywords (Opcional) *Recuerda separar las keywords con comas',
    pt: 'Keywords (Opcional) *Lembre-se de separar as keywords com vírgulas'
  },
  BUTTON_ADD_BUTTON: {
    es: 'Añadir botón',
    pt: 'Adicionar botão'
  },
  DOCUMENTS_PAYLOAD_LABEL: {
    es: 'Payload',
    pt: 'Payload'
  },
  DOCUMENTS_ADD_DOCUMENT: {
    es: 'Añadir documento',
    pt: 'Adicionar documento'
  },
  NEWMESSAGEBUTTON_BUTTON: {
    es: 'Añadir salto de mensaje',
    pt: 'Adicionar quebra de mensagem'
  },
  RESTAURANTS_BREADCRUMB: {
    es: 'Restaurantes',
    pt: 'Restaurantes'
  },
  RESTAURANTS_NEW_RESTAURANT: {
    es: 'Nuevo restaurante',
    pt: 'Novo restaurante'
  },
  RESTAURANTS_TABLE_HEADER_NAME: {
    es: 'Nombre',
    pt: 'Nome'
  },
  RESTAURANTS_TABLE_HEADER_PLATFORM: {
    es: 'Plataforma',
    pt: 'Plataforma'
  },
  RESTAURANTS_TABLE_HEADER_SMS: {
    es: 'SMS',
    pt: 'SMS'
  },
  RESTAURANTS_TABLE_HEADER_ACTIONS: {
    es: 'Acciones',
    pt: 'Ações'
  },
  RESTAURANTS_CONFIRM_DELETE_RESTAURANT: {
    es: '¿Estás seguro que desea eliminar el restaurante',
    pt: 'Tem certeza de que deseja excluir o restaurante?'
  },
  STORERESTAURANT_BREADCRUMB_RESTAURANTS: {
    es: 'Restaurantes',
    pt: 'Restaurantes'
  },
  STORERESTAURANT_BREADCRUMB_NEW_RESTAURANT: {
    es: 'Nuevo restaurante',
    pt: 'Novo restaurante'
  },
  STORERESTAURANT_FIELD_NAME_LABEL: {
    es: 'Nombre',
    pt: 'Nome'
  },
  STORERESTAURANT_FIELD_NAME_PLACEHOLDER: {
    es: 'Nombre del restaurante',
    pt: 'Nome do restaurante'
  },
  STORERESTAURANT_FIELD_CLIENT_ID_LABEL: {
    es: 'ID Cliente',
    pt: 'ID Cliente'
  },
  STORERESTAURANT_FIELD_CLIENT_ID_PLACEHOLDER: {
    es: 'ID del cliente',
    pt: 'ID do cliente'
  },
  STORERESTAURANT_FIELD_SMS_LABEL: {
    es: 'SMS',
    pt: 'SMS'
  },
  STORERESTAURANT_FIELD_SMS_RADIO_LABEL: {
    es: 'Seleccione una opción',
    pt: 'Selecione uma opção'
  },
  STORERESTAURANT_FIELD_SMS_YES: {
    es: 'Sí',
    pt: 'Sim'
  },
  STORERESTAURANT_FIELD_SMS_NO: {
    es: 'No',
    pt: 'Não'
  },
  STORERESTAURANT_FIELD_CLIENT_SMS_ID_LABEL: {
    es: 'ID Cliente SMS',
    pt: 'ID Cliente SMS'
  },
  STORERESTAURANT_FIELD_CLIENT_SMS_ID_PLACEHOLDER: {
    es: 'ID cliente SMS',
    pt: 'ID cliente SMS'
  },
  STORERESTAURANT_FIELD_SMS_KEY_LABEL: {
    es: 'Clave SMS',
    pt: 'Chave SMS'
  },
  STORERESTAURANT_FIELD_SMS_KEY_PLACEHOLDER: {
    es: 'Clave SMS',
    pt: 'Chave SMS'
  },
  STORERESTAURANT_FIELD_SMS_SENDER_LABEL: {
    es: 'Remitente SMS',
    pt: 'Remetente SMS'
  },
  STORERESTAURANT_FIELD_SMS_SENDER_PLACEHOLDER: {
    es: 'Remitente SMS',
    pt: 'Remetente SMS'
  },
  STORERESTAURANT_FIELD_SMS_TEXT_LABEL: {
    es: 'Texto SMS',
    pt: 'Texto SMS'
  },
  STORERESTAURANT_FIELD_SMS_TEXT_PLACEHOLDER: {
    es: 'Texto SMS',
    pt: 'Texto SMS'
  },
  STORERESTAURANT_FIELD_SMS_ROUTE_LABEL: {
    es: 'Ruta SMS',
    pt: 'Rota SMS'
  },
  STORERESTAURANT_FIELD_SMS_ROUTE_PLACEHOLDER: {
    es: 'Ruta SMS',
    pt: 'Rota SMS'
  },
  STORERESTAURANT_FIELD_SMS_ALPHABET_LABEL: {
    es: 'Alfabeto SMS',
    pt: 'Alfabeto SMS'
  },
  STORERESTAURANT_FIELD_SMS_ALPHABET_PLACEHOLDER: {
    es: 'Alfabeto SMS',
    pt: 'Alfabeto SMS'
  },
  STORERESTAURANT_FIELD_PLATFORM_LABEL: {
    es: 'Plataforma',
    pt: 'Plataforma'
  },
  STORERESTAURANT_FIELD_ID_LABEL: {
    es: 'ID',
    pt: 'ID'
  },
  STORERESTAURANT_FIELD_ID_PLACEHOLDER: {
    es: 'ID',
    pt: 'ID'
  },
  STORERESTAURANT_FIELD_API_KEY_LABEL: {
    es: 'API KEY',
    pt: 'API KEY'
  },
  STORERESTAURANT_FIELD_API_KEY_PLACEHOLDER: {
    es: 'API KEY',
    pt: 'API KEY'
  },
  STORERESTAURANT_FIELD_HOST_LABEL: {
    es: 'Host',
    pt: 'Host'
  },
  STORERESTAURANT_FIELD_HOST_PLACEHOLDER: {
    es: 'Host',
    pt: 'Host'
  },
  STORERESTAURANT_FIELD_DINERS_LABEL: {
    es: 'Comensales',
    pt: 'Comensais'
  },
  STORERESTAURANT_FIELD_DINERS_PLACEHOLDER: {
    es: 'Comensales',
    pt: 'Comensais'
  },
  STORERESTAURANT_FIELD_AGENT_LABEL: {
    es: 'Agente',
    pt: 'Agente'
  },
  STORERESTAURANT_FIELD_AGENT_PLACEHOLDER: {
    es: 'Agente',
    pt: 'Agente'
  },
  STORERESTAURANT_SAVE_BUTTON: {
    es: 'Guardar',
    pt: 'Salvar'
  },
  UPDATERESTAURANT_BREADCRUMB_RESTAURANTS: {
    es: 'Restaurantes',
    pt: 'Restaurantes'
  },
  UPDATERESTAURANT_BREADCRUMB_NEW_RESTAURANT: {
    es: 'Nuevo restaurante',
    pt: 'Novo restaurante'
  },
  UPDATERESTAURANT_FIELD_NAME_LABEL: {
    es: 'Nombre',
    pt: 'Nome'
  },
  UPDATERESTAURANT_FIELD_NAME_PLACEHOLDER: {
    es: 'Nombre del restaurante',
    pt: 'Nome do restaurante'
  },
  UPDATERESTAURANT_FIELD_CLIENT_ID_LABEL: {
    es: 'ID Cliente',
    pt: 'ID Cliente'
  },
  UPDATERESTAURANT_FIELD_CLIENT_ID_PLACEHOLDER: {
    es: 'ID del cliente',
    pt: 'ID do cliente'
  },
  UPDATERESTAURANT_FIELD_SMS_LABEL: {
    es: 'SMS',
    pt: 'SMS'
  },
  UPDATERESTAURANT_FIELD_SMS_YES: {
    es: 'Sí',
    pt: 'Sim'
  },
  UPDATERESTAURANT_FIELD_SMS_NO: {
    es: 'No',
    pt: 'Não'
  },
  UPDATERESTAURANT_FIELD_CLIENT_SMS_ID_LABEL: {
    es: 'ID Cliente SMS',
    pt: 'ID Cliente SMS'
  },
  UPDATERESTAURANT_FIELD_CLIENT_SMS_ID_PLACEHOLDER: {
    es: 'ID cliente SMS',
    pt: 'ID cliente SMS'
  },
  UPDATERESTAURANT_FIELD_SMS_KEY_LABEL: {
    es: 'Clave SMS',
    pt: 'Chave SMS'
  },
  UPDATERESTAURANT_FIELD_SMS_KEY_PLACEHOLDER: {
    es: 'Clave SMS',
    pt: 'Chave SMS'
  },
  UPDATERESTAURANT_FIELD_SMS_SENDER_LABEL: {
    es: 'Remitente SMS',
    pt: 'Remetente SMS'
  },
  UPDATERESTAURANT_FIELD_SMS_SENDER_PLACEHOLDER: {
    es: 'Remitente SMS',
    pt: 'Remetente SMS'
  },
  UPDATERESTAURANT_FIELD_SMS_TEXT_LABEL: {
    es: 'Texto SMS',
    pt: 'Texto SMS'
  },
  UPDATERESTAURANT_FIELD_SMS_TEXT_PLACEHOLDER: {
    es: 'Texto SMS',
    pt: 'Texto SMS'
  },
  UPDATERESTAURANT_FIELD_SMS_ROUTE_LABEL: {
    es: 'Ruta SMS',
    pt: 'Rota SMS'
  },
  UPDATERESTAURANT_FIELD_SMS_ROUTE_PLACEHOLDER: {
    es: 'Ruta SMS',
    pt: 'Rota SMS'
  },
  UPDATERESTAURANT_FIELD_SMS_ALPHABET_LABEL: {
    es: 'Alfabeto SMS',
    pt: 'Alfabeto SMS'
  },
  UPDATERESTAURANT_FIELD_SMS_ALPHABET_PLACEHOLDER: {
    es: 'Alfabeto SMS',
    pt: 'Alfabeto SMS'
  },
  UPDATERESTAURANT_FIELD_PLATFORM_LABEL: {
    es: 'Plataforma',
    pt: 'Plataforma'
  },
  UPDATERESTAURANT_FIELD_ID_LABEL: {
    es: 'ID',
    pt: 'ID'
  },
  UPDATERESTAURANT_FIELD_ID_PLACEHOLDER: {
    es: 'ID',
    pt: 'ID'
  },
  UPDATERESTAURANT_FIELD_API_KEY_LABEL: {
    es: 'API KEY',
    pt: 'API KEY'
  },
  UPDATERESTAURANT_FIELD_API_KEY_PLACEHOLDER: {
    es: 'API KEY',
    pt: 'API KEY'
  },
  UPDATERESTAURANT_FIELD_HOST_LABEL: {
    es: 'Host',
    pt: 'Host'
  },
  UPDATERESTAURANT_FIELD_HOST_PLACEHOLDER: {
    es: 'Host',
    pt: 'Host'
  },
  UPDATERESTAURANT_FIELD_DINERS_LABEL: {
    es: 'Comensales',
    pt: 'Comensais'
  },
  UPDATERESTAURANT_FIELD_DINERS_PLACEHOLDER: {
    es: 'Comensales',
    pt: 'Comensais'
  },
  UPDATERESTAURANT_FIELD_AGENT_LABEL: {
    es: 'Agente',
    pt: 'Agente'
  },
  UPDATERESTAURANT_FIELD_AGENT_PLACEHOLDER: {
    es: 'Agente',
    pt: 'Agente'
  },
  UPDATERESTAURANT_SAVE_BUTTON: {
    es: 'Guardar',
    pt: 'Salvar'
  },
  BREADCRUMB_BREADCRUMB_PHRASES_AND_ANSWERS: {
    es: 'Frases y respuestas',
    pt: 'Frases e respostas'
  },
  BREADCRUMB_BREADCRUMB_ANSWERS: {
    es: 'Respuestas',
    pt: 'Respostas'
  },
  NAVBAR_ITEM_CHATBOTS: {
    es: 'Chatbots',
    pt: 'Chatbots'
  },
  NAVBAR_ITEM_TRAINING: {
    es: 'Entrenamiento',
    pt: 'Treinamento'
  },
  NAVBAR_ITEM_CONTACTS: {
    es: 'Contactos',
    pt: 'Contactos'
  },
  NAVBAR_ITEM_CONVERSATIONS: {
    es: 'Conversaciones',
    pt: 'Conversas'
  },
  NAVBAR_ITEM_METRICS: {
    es: 'Métricas',
    pt: 'Métricas'
  },
  NAVBAR_CONTACTS_ALL: {
    es: 'Todos',
    pt: 'Todos'
  },
  NAVBAR_RESTAURANTS: {
    es: 'Restaurantes',
    pt: 'Restaurantes'
  },
  NAVBAR_WIDGET: {
    es: 'Widget',
    pt: 'Widget'
  },
  NAVBAR_LOG_OUT: {
    es: 'Logout',
    pt: 'Sair'
  },
  ANSWERS_NEW_COMMON_ANSWER: {
    es: 'Nueva respuesta común',
    pt: 'Nova resposta comum'
  },
  ANSWERS_NEW_DOUBT_ANSWER: {
    es: 'Nueva respuesta de duda',
    pt: 'Nova resposta de dúvida'
  },
  ANSWERS_GPT_PROMPT: {
    es: 'Prompt de ChatGPT',
    pt: 'Prompt do ChatGPT'
  },
  ANSWERS_TABLE_HEADER_LANGUAGE: {
    es: 'Idioma',
    pt: 'Idioma'
  },
  ANSWERS_TABLE_HEADER_ANSWERS: {
    es: 'Respuestas',
    pt: 'Respostas'
  },
  ANSWERS_TABLE_HEADER_GPT_PROMPT: {
    es: 'Prompt GPT',
    pt: 'Prompt GPT'
  },
  ANSWERS_TABLE_HEADER_PROCESS_CONN: {
    es: 'Conexión con proceso',
    pt: 'Conexão com processo'
  },
  ANSWERS_CONFIRM_DELETE_RESPONSE: {
    es: '¿Estás seguro de borrar esta respuesta?',
    pt: 'Tem certeza de que deseja excluir esta resposta?'
  },
  CONNECTIONANSWER_TOP_TITLE: {
    es: 'Configuración de respuesta con conexión',
    pt: 'Configuração de resposta com conexão'
  },
  CONNECTIONANSWER_PROCESS_LABEL: {
    es: 'Proceso',
    pt: 'Processo'
  },
  CONNECTIONANSWER_PROCESS_PLACEHOLDER: {
    es: 'URL del proceso',
    pt: 'URL do processo'
  },
  CONNECTIONANSWER_METHOD_LABEL: {
    es: 'Método',
    pt: 'Método'
  },
  CONNECTIONANSWER_CONTENT_TYPE_LABEL: {
    es: 'Content-Type',
    pt: 'Content-Type'
  },
  CONNECTIONANSWER_SUBS_PARAM_LABEL: {
    es: 'Parámetros de sustitución',
    pt: 'Parâmetros de substituição'
  },
  CONNECTIONANSWER_SUBS_PARAMS_PLACEHOLDER: {
    es: 'TERMINO_A_ENCONTRAR: {nombre_parametro}',
    pt: 'TERMO_A_ENCONTRAR: {nome_parametro}'
  },
  CONNECTIONANSWER_URL_PARAMS_LABEL: {
    es: 'Parámetros de la URL de proceso',
    pt: 'Parâmetros da URL do processo'
  },
  CONNECTIONANSWER_URL_PARAMS_PLACEHOLDER: {
    es: 'Parámetros',
    pt: 'Parâmetros'
  },
  CONNECTIONANSWER_ERROR_RESPONSE_LABEL: {
    es: 'Respuesta en caso que la conexión con el proceso no funcione',
    pt: 'Resposta caso a conexão com o processo não funcione'
  },
  CONNECTIONANSWER_ERROR_RESPONSE_PLACEHOLDER: {
    es: 'Parámetros',
    pt: 'Parâmetros'
  },
  CONNECTIONANSWER_HELP_RESPONSE_LABEL: {
    es: 'Respuesta de ayuda',
    pt: 'Resposta de ajuda'
  },
  CONNECTIONANSWER_HELP_RESPONSE_PLACEHOLDER: {
    es: 'Escribe aquí el texto del mensaje',
    pt: 'Escreva aqui o texto da mensagem'
  },
  CONNECTIONANSWER_SAVE_BUTTON: {
    es: 'Guardar',
    pt: 'Salvar'
  },
  SENTENCEANSWERS_BREADCRUMB_CHATBOTS: {
    es: 'Chatbots',
    pt: 'Chatbots'
  },
  SENTENCEANSWERS_BREADCRUMB_ANSWERS: {
    es: 'Respuestas',
    pt: 'Respostas'
  },
  SENTENCEANSWERS_NEW_ANSWER: {
    es: 'Nueva Respuesta',
    pt: 'Nova Resposta'
  },
  SENTENCEANSWERS_GPT_PROMPT: {
    es: 'Prompt de ChatGPT',
    pt: 'Prompt do ChatGPT'
  },
  SENTENCEANSWERS_TABLE_HEADER_ANSWER: {
    es: 'Respuesta',
    pt: 'Resposta'
  },
  SENTENCEANSWERS_TABLE_HEADER_GPT_PROMPT: {
    es: 'Prompt GPT',
    pt: 'Prompt GPT'
  },
  SENTENCEANSWERS_TABLE_HEADER_PROCESS_CONN: {
    es: 'Conexión con proceso',
    pt: 'Conexão com processo'
  },
  SENTENCEANSWERS_CONFIRM_DELETE_ANSWER: {
    es: '¿Estás seguro de borrar esta respuesta?',
    pt: 'Tem certeza de que deseja excluir esta resposta?'
  },
  STOREANSWER_BREADCRUMB_CHATBOTS: {
    es: 'Chatbots',
    pt: 'Chatbots'
  },
  STOREANSWER_BREADCRUMB_ANSWERS: {
    es: 'Respuestas',
    pt: 'Respostas'
  },
  STOREANSWER_BREADCRUMB_COMMON_ANSWERS: {
    es: 'Respuestas comunes',
    pt: 'Respostas comuns'
  },
  STOREANSWER_BREADCRUMB_DOUBT_ANSWERS: {
    es: 'Respuestas de duda',
    pt: 'Respostas de dúvida'
  },
  STOREANSWER_BREADCRUMB_NEW_COMMON_ANSWER: {
    es: 'Nueva respuesta común',
    pt: 'Nova resposta comum'
  },
  STOREANSWER_BREADCRUMB_NEW_DOUBT_ANSWER: {
    es: 'Nueva respuesta de duda',
    pt: 'Nova resposta de dúvida'
  },
  STOREANSWER_BREADCRUMB_NEW_ANSWER: {
    es: 'Nueva respuesta',
    pt: 'Nova resposta'
  },
  STOREANSWER_TABS_SIMPLE: {
    es: 'Simple',
    pt: 'Simples'
  },
  STOREANSWER_TABS_COMPLEX: {
    es: 'Compleja',
    pt: 'Complexa'
  },
  STOREANSWER_SET_UP_CONN: {
    es: 'Configurar conexión',
    pt: 'Configurar conexão'
  },
  STOREANSWER_INPUT_ANSWER_LABEL: {
    es: 'Respuesta',
    pt: 'Resposta'
  },
  STOREANSWER_INPUT_ANSWER_PLACEHOLDER: {
    es: 'Escribe aquí el texto del mensaje',
    pt: 'Escreva aqui o texto da mensagem'
  },
  STOREANSWER_NEW_FILE: {
    es: 'Nuevo archivo',
    pt: 'Novo arquivo'
  },
  STOREANSWER_GUIDED_DIALOG_LABEL: {
    es: 'Diálogo guiado',
    pt: 'Diálogo guiado'
  },
  STOREANSWER_WARNING_LENGTH_ERROR: {
    es: 'El texto del botón supera 20 caracteres',
    pt: 'O texto do botão excede 20 caracteres'
  },
  STOREANSWER_LOW_LINE_ERROR: {
    es: 'El texto contiene el caracter "_"',
    pt: 'O texto contém o caractere "_"'
  },
  STOREANSWER_NAVIGATION_BUTTONS: {
    es: 'Botones de navegación',
    pt: 'Botões de navegação'
  },
  STOREANSWER_MULTISELECT: {
    es: 'Multiselección de botones',
    pt: 'Multiseleção de botões'
  },
  STOREANSWER_INPUT_PAYLOAD_PLACEHOLDER: {
    es: 'Payload',
    pt: 'Payload'
  },
  STOREANSWER_INPUT_BUTTON_TEXT_PLACEHOLDER: {
    es: 'Texto del botón',
    pt: 'Texto do botão'
  },
  STOREANSWER_INPUT_KEYWORDS_PLACEHOLDER: {
    es: 'Keywords (separar con coma)',
    pt: 'Keywords (separar com vírgula)'
  },
  STOREANSWER_INPUT_FREE_TEXT_LABEL: {
    es: 'Texto libre',
    pt: 'Texto livre'
  },
  STOREANSWER_FREE_TEXT_INPUT_PARAM_NAME_PLACEHOLDER: {
    es: 'Nombre parámetro',
    pt: 'Nome do parâmetro'
  },
  STOREANSWER_INPUT_FORCE_NEXT_INT_LABEL: {
    es: 'Forzar próxima intención',
    pt: 'Forçar próxima intenção'
  },
  STOREANSWER_SAVE_BUTTON: {
    es: 'Guardar',
    pt: 'Salvar'
  },
  STORECHATGPTPROMPT_BREADCRUMB_CHATBOTS: {
    es: 'Chatbots',
    pt: 'Chatbots'
  },
  STORECHATGPTPROMPT_BREADCRUMB_ANSWERS: {
    es: 'Respuestas',
    pt: 'Respostas'
  },
  STORECHATGPTPROMPT_BREADCRUMB_COMMON_ANSWERS: {
    es: 'Respuestas comunes',
    pt: 'Respostas comuns'
  },
  STORECHATGPTPROMPT_BREADCRUMB_DOUBT_ANSWERS: {
    es: 'Respuestas de dudas',
    pt: 'Respostas de dúvida'
  },
  STORECHATGPTPROMPT_BREADCRUMB_NEW_PROMPT: {
    es: 'Nuevo Prompt - Chat GPT',
    pt: 'Novo Prompt - Chat GPT'
  },
  STORECHATGPTPROMPT_TABS_SIMPLE: {
    es: 'Simple',
    pt: 'Simples'
  },
  STORECHATGPTPROMPT_TABS_COMPLEX: {
    es: 'Compleja',
    pt: 'Complexa'
  },
  STORECHATGPTPROMPT_SET_UP_CONN: {
    es: 'Configurar conexión',
    pt: 'Configurar conexão'
  },
  STORECHATGPTPROMPT_VISIBLE_FOR_USER: {
    es: 'Visible para el usuario',
    pt: 'Visível para o usuário'
  },
  STORECHATGPTPROMPT_SYSTEM_INTERNAL: {
    es: 'Interna del sistema (no visible)',
    pt: 'Interna do sistema (não visível)'
  },
  STORECHATGPTPROMPT_INPUT_PROMPT_DESCRIPTION_LABEL: {
    es: 'Breve descripción del prompt',
    pt: 'Breve descrição do prompt'
  },
  STORECHATGPTPROMPT_INPUT_GPT_PROMPT_LABEL: {
    es: 'Prompt para Chat GPT',
    pt: 'Prompt para Chat GPT'
  },
  STORECHATGPTPROMPT_INPUT_GPT_PROMPT_PLACEHOLDER: {
    es: 'Escribe aquí el prompt',
    pt: 'Escreva aqui o prompt'
  },
  STORECHATGPTPROMPT_GPT_PROMPT_ANSWER_LABEL: {
    es: 'Independientemente de la respuesta de ChatGPT',
    pt: 'Independentemente da resposta do ChatGPT'
  },
  STORECHATGPTPROMPT_GPT_PROMPT_EXECUTE_LABEL: {
    es: 'Ejecutar',
    pt: 'Correr'
  },
  STORECHATGPTPROMPT_NEW_FILE_BUTTON: {
    es: 'Nuevo archivo',
    pt: 'Novo arquivo'
  },
  STORECHATGPTPROMPT_PROCESS_ANSWER_BUTTON: {
    es: 'Resp. proceso',
    pt: 'Resp. processo'
  },
  STORECHATGPTPROMPT_USER_QUESTION_BUTTON: {
    es: 'Pregunta del usuario',
    pt: 'Pergunta do usuário'
  },
  STORECHATGPTPROMPT_THEME_BUTTON: {
    es: 'Temática',
    pt: 'Temática'
  },
  STORECHATGPTPROMPT_DOCUMENT_BUTTON: {
    es: 'Documento',
    pt: 'Documento'
  },
  STORECHATGPTPROMPT_INPUT_BASED_ON_PAYLOAD_LABEL: {
    es: 'Según el payload encontrado en la respuesta de ChatGPT',
    pt: 'Conforme o payload encontrado na resposta do ChatGPT'
  },
  STORECHATGPTPROMPT_EXECUTE_LABEL: {
    es: 'Ejecutar',
    pt: 'Executar'
  },
  STORECHATGPTPROMPT_INPUT_FOUND_PAYLOAD_GPT_PLACEHOLDER: {
    es: 'Payload encontrado en respuesta ChatGPT',
    pt: 'Payload encontrado na resposta do ChatGPT'
  },
  STORECHATGPTPROMPT_INPUT_DESTINY_PAYLOAD_KDCA_PLACEHOLDER: {
    es: 'Payload destino (KDCA)',
    pt: 'Payload destino (KDCA)'
  },
  STORECHATGPTPROMPT_INPUT_IF_PREVIOUS_NOT_FOUND_LABEL: {
    es: 'Si no encuentra ninguno de los anteriores...',
    pt: 'Se não encontrar nenhum dos anteriores...'
  },
  STORECHATGPTPROMPT_SAVE_BUTTON: {
    es: 'Guardar',
    pt: 'Salvar'
  },
  UPDATEANSWER_BREADCRUMB_CHATBOTS: {
    es: 'Chatbots',
    pt: 'Chatbots'
  },
  UPDATEANSWER_BREADCRUMB_ANSWERS: {
    es: 'Respuestas',
    pt: 'Respostas'
  },
  UPDATEANSWER_BREADCRUMB_COMMON_ANSWERS: {
    es: 'Respuestas comunes',
    pt: 'Respostas comuns'
  },
  UPDATEANSWER_BREADCRUMB_DOUBT_ANSWERS: {
    es: 'Respuestas de duda',
    pt: 'Respostas de dúvida'
  },
  UPDATEANSWER_BREADCRUMB_UPDATE_ANSWER: {
    es: 'Actualizar respuesta',
    pt: 'Atualizar resposta'
  },
  UPDATEANSWER_TABS_SIMPLE: {
    es: 'Simple',
    pt: 'Simples'
  },
  UPDATEANSWER_TABS_COMPLEX: {
    es: 'Compleja',
    pt: 'Complexa'
  },
  UPDATEANSWER_SET_UP_CONN: {
    es: 'Configurar conexión',
    pt: 'Configurar conexão'
  },
  UPDATEANSWER_RESPONSE_SECTION_LABEL: {
    es: 'Respuesta',
    pt: 'Resposta'
  },
  UPDATEANSWER_RESPONSES_WRITE_PLACEHOLDER: {
    es: 'Escribe aquí el texto del mensaje',
    pt: 'Escreva aqui o texto da mensagem'
  },
  UPDATEANSWER_BUTTON_ADD_FILE: {
    es: 'Nuevo archivo',
    pt: 'Novo arquivo'
  },
  UPDATEANSWER_BUTTON_SHOW_EMOJI: {
    es: '😀',
    pt: '😀'
  },
  UPDATEANSWER_BUTTON_SHOW_EMOJI_FILE: {
    es: '📎',
    pt: '📎'
  },
  UPDATEANSWER_GUIDED_DIALOG_LABEL: {
    es: 'Diálogo guiado',
    pt: 'Diálogo guiado'
  },
  UPDATEANSWER_WARNING_LENGTH_ERROR: {
    es: 'El texto del botón supera 20 caracteres',
    pt: 'O texto do botão excede 20 caracteres'
  },
  UPDATEANSWER_LOW_LINE_ERROR: {
    es: 'El texto contiene el caracter "_"',
    pt: 'O texto contém o caractere "_"'
  },
  UPDATEANSWER_NAVIGATION_BUTTONS: {
    es: 'Botones de navegación',
    pt: 'Botões de navegação'
  },
  UPDATEANSWER_MULTISELECT: {
    es: 'Multiselección de botones',
    pt: 'Seleção múltipla de botões'
  },
  UPDATEANSWER_INPUT_PAYLOAD_PLACEHOLDER: {
    es: 'Payload',
    pt: 'Payload'
  },
  UPDATEANSWER_INPUT_BUTTON_TEXT_PLACEHOLDER: {
    es: 'Texto del botón',
    pt: 'Texto do botão'
  },
  UPDATEANSWER_INPUT_KEYWORDS_PLACEHOLDER: {
    es: 'Keywords (separar con coma)',
    pt: 'Palavras-chave (separadas por vírgula)'
  },
  UPDATEANSWER_INPUT_FREE_TEXT_LABEL: {
    es: 'Texto libre',
    pt: 'Texto livre'
  },
  UPDATEANSWER_FREE_TEXT_INPUT_PAYLOAD_DIALOG_SELECTED1: {
    es: 'Payload',
    pt: 'Payload'
  },
  UPDATEANSWER_FREE_TEXT_INPUT_PARAM_NAME_SELECTED1: {
    es: 'Nombre parámetro',
    pt: 'Nome do parâmetro'
  },
  UPDATEANSWER_INPUT_FORCE_NEXT_INT_LABEL: {
    es: 'Forzar próxima intención',
    pt: 'Forçar próxima intenção'
  },
  UPDATEANSWER_LOW_LINE_ERROR_SELECTED2: {
    es: 'El texto contiene el caracter "_"',
    pt: 'O texto contém o caractere "_"'
  },
  UPDATEANSWER_PAYLOAD_DIALOG_PLACEHOLDER: {
    es: 'Payload',
    pt: 'Payload'
  },
  UPDATEANSWER_SAVE_BUTTON: {
    es: 'Guardar',
    pt: 'Salvar'
  },
  UPDATECHATGPTPROMPT__BREADCRUMB_CHATBOTS: {
    es: 'Chatbots',
    pt: 'Chatbots'
  },
  UPDATECHATGPTPROMPT_BREADCRUMB_ANSWERS: {
    es: 'Respuestas',
    pt: 'Respostas'
  },
  UPDATECHATGPTPROMPT_BREADCRUMB_COMMON_ANSWERS: {
    es: 'Respuestas comunes',
    pt: 'Respostas comuns'
  },
  UPDATECHATGPTPROMPT_BREADCRUMB_DOUBT_ANSWERS: {
    es: 'Respuestas de duda',
    pt: 'Respostas de dúvida'
  },
  UPDATECHATGPTPROMPT_BREADCRUMB_UPDATE_PROMPT: {
    es: 'Actualizar Prompt - Chat GPT',
    pt: 'Atualizar Prompt - Chat GPT'
  },
  UPDATECHATGPTPROMPT_TABS_SIMPLE: {
    es: 'Simple',
    pt: 'Simples'
  },
  UPDATECHATGPTPROMPT_TABS_COMPLEX: {
    es: 'Compleja',
    pt: 'Complexa'
  },
  UPDATECHATGPTPROMPT_SET_UP_CONN: {
    es: 'Configurar conexión',
    pt: 'Configurar conexão'
  },
  UPDATECHATGPTPROMPT_VISIBLE_FOR_USER: {
    es: 'Visible para el usuario',
    pt: 'Visível para o usuário'
  },
  UPDATECHATGPTPROMPT_SYSTEM_INTERNAL: {
    es: 'Interna del sistema (no visible)',
    pt: 'Interna do sistema (não visível)'
  },
  UPDATECHATGPTPROMPT_INPUT_PROMPT_DESCRIPTION_LABEL: {
    es: 'Breve descripción del prompt',
    pt: 'Breve descrição do prompt'
  },
  UPDATECHATGPTPROMPT_INPUT_GPT_PROMPT_LABEL: {
    es: 'Prompt para Chat GPT',
    pt: 'Prompt para Chat GPT'
  },
  UPDATECHATGPTPROMPT_INPUT_GPT_PROMPT_PLACEHOLDER: {
    es: 'Escribe aquí el prompt',
    pt: 'Escreva aqui o prompt'
  },
  UPDATECHATGPTPROMPT_NEW_FILE_BUTTON: {
    es: 'Nuevo archivo',
    pt: 'Novo arquivo'
  },
  UPDATECHATGPTPROMPT_PROCESS_ANSWER_BUTTON: {
    es: 'Resp. proceso',
    pt: 'Resp. processo'
  },
  UPDATECHATGPTPROMPT_USER_QUESTION_BUTTON: {
    es: 'Pregunta del usuario',
    pt: 'Pergunta do usuário'
  },
  UPDATECHATGPTPROMPT_THEME_BUTTON: {
    es: 'Temática',
    pt: 'Tema'
  },
  UPDATECHATGPTPROMPT_DOCUMENT_BUTTON: {
    es: 'Documento',
    pt: 'Documento'
  },
  UPDATECHATGPTPROMPT_INPUT_BASED_ON_PAYLOAD_LABEL: {
    es: 'Según el payload encontrado en la respuesta de ChatGPT',
    pt: 'Baseado no payload encontrado na resposta do ChatGPT'
  },
  UPDATECHATGPTPROMPT_EXECUTE_LABEL: {
    es: 'Ejecutar',
    pt: 'Executar'
  },
  UPDATECHATGPTPROMPT_INPUT_FOUND_PAYLOAD_GPT_PLACEHOLDER: {
    es: 'Payload encontrado en respuesta ChatGPT',
    pt: 'Payload encontrado na resposta do ChatGPT'
  },
  UPDATECHATGPTPROMPT_INPUT_DESTINY_PAYLOAD_KDCA_PLACEHOLDER: {
    es: 'Payload destino (KDCA)',
    pt: 'Payload de destino (KDCA)'
  },
  UPDATECHATGPTPROMPT_INPUT_IF_PREVIOUS_NOT_FOUND_LABEL: {
    es: 'Si no encuentra ninguno de los anteriores...',
    pt: 'Se não encontrar nenhum dos anteriores...'
  },
  UPDATECHATGPTPROMPT_INPUT_DESTINY_PAYLOAD_KDCA_PROMPT_OPTIONS: {
    es: 'Payload destino (KDCA)',
    pt: 'Payload de destino (KDCA)'
  },
  UPDATECHATGPTPROMPT_INPUT_PAYLOAD_FORM: {
    es: 'Independientemente de la respuesta de ChatGPT',
    pt: 'Independentemente da resposta do ChatGPT'
  },
  UPDATECHATGPTPROMPT_EXECUTE_FORM: {
    es: 'Ejecutar',
    pt: 'Correr'
  },
  UPDATECHATGPTPROMPT_INPUT_PAYLOAD_KDCA_PROMPT_INDEPENT_PLACEHOLDER: {
    es: 'Payload destino (KDCA)',
    pt: 'Payload de destino (KDCA)'
  },
  UPDATECHATGPTPROMPT_SAVE_BUTTON: {
    es: 'Guardar',
    pt: 'Salvar'
  },
  SENTENCES_BUTTON_NEW_PHRASE: {
    es: 'Nueva frase',
    pt: 'Nova frase'
  },
  SENTENCES_THEAD_LANGUAGE: {
    es: 'Idioma',
    pt: 'Idioma'
  },
  SENTENCES_THEAD_INTENT: {
    es: 'Intención',
    pt: 'Intenção'
  },
  SENTENCES_THEAD_PHRASE: {
    es: 'Frase',
    pt: 'Frase'
  },
  SENTENCES_THEAD_KEYWORDS: {
    es: 'Keywords',
    pt: 'Palavras-chave'
  },
  SENTENCES_THEAD_OK: {
    es: '#OK',
    pt: '#OK'
  },
  SENTENCES_THEAD_KO: {
    es: '#KO',
    pt: '#KO'
  },
  SENTENCES_THEAD_ANSWER: {
    es: 'Resp',
    pt: 'Resposta'
  },
  SENTENCES_THEAD_END: {
    es: 'Fin',
    pt: 'Fim'
  },
  SENTENCES_THEAD_PRIORITY: {
    es: 'Prioridad',
    pt: 'Prioridade'
  },
  STORESENTENCE_BREADCRUMB_CHATBOTS: {
    es: 'Chatbots',
    pt: 'Chatbots'
  },
  STORESENTENCE_BREADCRUMB_PHRASE: {
    es: 'Frases',
    pt: 'Frases'
  },
  SENTENCEANSWERS_NEW_PHRASE: {
    es: 'Nueva Frase',
    pt: 'Nova Frase'
  },
  STORESENTENCE_FIELD_PHRASE_LABEL: {
    es: 'Frase',
    pt: 'Frase'
  },
  STORESENTENCE_FIELD_PHRASE_PLACEHOLDER: {
    es: 'Frase',
    pt: 'Frase'
  },
  STORESENTENCE_FIELD_KEYWORDS_LABEL: {
    es: 'Keywords',
    pt: 'Palavras-chave'
  },
  STORESENTENCE_FIELD_KEYWORDS_PLACEHOLDER: {
    es: 'Keywords separadas por comas',
    pt: 'Palavras-chave separadas por vírgulas'
  },
  STORESENTENCE_FIELD_PRIORITY_LABEL: {
    es: 'Prioridad',
    pt: 'Prioridade'
  },
  STORESENTENCE_FIELD_PRIORITY_PLACEHOLDER: {
    es: 'Prioridad',
    pt: 'Prioridade'
  },
  STORESENTENCE_FIELD_LANGUAGE_LABEL: {
    es: 'Idioma',
    pt: 'Idioma'
  },
  STORESENTENCE_FIELD_END_BOT_LABEL: {
    es: 'Finaliza el Bot',
    pt: 'Termina o Bot'
  },
  STORESENTENCE_SAVE_BUTTON: {
    es: 'Guardar',
    pt: 'Salvar'
  },
  UPDATESENTENCE_BREADCRUMB_CHATBOTS: {
    es: 'Chatbots',
    pt: 'Chatbots'
  },
  UPDATESENTENCE_BREADCRUMB_PHRASES: {
    es: 'Frases',
    pt: 'Frases'
  },
  UPDATESENTENCE_BREADCRUMB_UPDATE_PHRASE: {
    es: 'Actualizar Frase',
    pt: 'Atualizar Frase'
  },
  UPDATESENTENCE_FIELD_PHRASE_LABEL: {
    es: 'Frase',
    pt: 'Frase'
  },
  UPDATESENTENCE_FIELD_PHRASE_PLACEHOLDER: {
    es: 'Frase',
    pt: 'Frase'
  },
  UPDATESENTENCE_FIELD_KEYWORDS_LABEL: {
    es: 'Keywords',
    pt: 'Palavras-chave'
  },
  UPDATESENTENCE_FIELD_KEYWORDS_PLACEHOLDER: {
    es: 'Keywords separadas por comas',
    pt: 'Palavras-chave separadas por vírgulas'
  },
  UPDATESENTENCE_FIELD_PRIORITY_LABEL: {
    es: 'Prioridad',
    pt: 'Prioridade'
  },
  UPDATESENTENCE_FIELD_PRIORITY_PLACEHOLDER: {
    es: 'Prioridad',
    pt: 'Prioridade'
  },
  UPDATESENTENCE_FIELD_LANGUAGE_LABEL: {
    es: 'Idioma',
    pt: 'Idioma'
  },
  UPDATESENTENCE_FIELD_END_BOT_LABEL: {
    es: 'Finaliza el Bot',
    pt: 'Finaliza o Bot'
  },
  UPDATESENTENCE_SAVE_BUTTON: {
    es: 'Guardar',
    pt: 'Salvar'
  },
  SENTENCESANDANSWERS_BREADCRUMB_CHATBOTS: {
    es: 'Chatbots',
    pt: 'Chatbots'
  },
  SENTENCESANDANSWERS_BREADCRUMB_PHRASES_ANSWERS: {
    es: 'Frases y respuestas',
    pt: 'Frases e Respostas'
  },
  SENTENCESANDANSWERS_TABS_PHRASES: {
    es: 'Frases',
    pt: 'Frases'
  },
  SENTENCESANDANSWERS_COMMON_ANSWERS: {
    es: 'Respuestas Comunes',
    pt: 'Respostas Comuns'
  },
  SENTENCESANDANSWERS_DEFAULT_ANSWERS: {
    es: 'Respuestas de duda',
    pt: 'Respostas de Dúvida'
  },
  INTENTS_BREADCRUMB_CHATBOTS: {
    es: 'Chatbots',
    pt: 'Chatbots'
  },
  INTENTS_BREADCRUMB_INTENTS: {
    es: 'Intenciones',
    pt: 'Intenções'
  },
  INTENTS_NEW_INTENT: {
    es: 'Nueva Intención',
    pt: 'Nova Intenção'
  },
  INTENTS_THEME_FILTER: {
    es: 'Temática',
    pt: 'Tema'
  },
  INTENTS_INPUT_LOOKFOR_INTENT_PLACEHOLDER: {
    es: 'Buscar intención (Esc para cancelar)',
    pt: 'Buscar intenção (Pressione Esc para cancelar)'
  },
  INTENTS_THEAD_NAME: {
    es: 'Nombre',
    pt: 'Nome'
  },
  INTENTS_THEAD_THEME: {
    es: 'Temática',
    pt: 'Tema'
  },
  INTENTS_THEAD_PHRASES: {
    es: 'Frases',
    pt: 'Frases'
  },
  INTENTS_THEAD_CLOCK_EMOJI: {
    es: '⏱',
    pt: '⏱'
  },
  INTENTS_THEAD_MATCH_OK_KO: {
    es: '#MATCHOK / #MATCHKO',
    pt: '#MATCHOK / #MATCHKO'
  },
  INTENTS_THEAD_MATCH_OK_KO_EMOJI: {
    es: '👍 / 👎',
    pt: '👍 / 👎'
  },
  STOREINTENT_BREADCRUMB_CHATBOTS: {
    es: 'Chatbots',
    pt: 'Chatbots'
  },
  STOREINTENT_BREADCRUMB_INTENTS: {
    es: 'Intenciones',
    pt: 'Intenções'
  },
  STOREINTENT_NEW_INTENT: {
    es: 'Nueva Intención',
    pt: 'Nova Intenção'
  },
  STOREINTENT_FIELD_NAME_LABEL: {
    es: 'Nombre',
    pt: 'Nome'
  },
  STOREINTENT_FIELD_NAME_PLACEHOLDER: {
    es: 'Nombre de la intención',
    pt: 'Nome da intenção'
  },
  STOREINTENT_FIELD_DESCRIPTION_LABEL: {
    es: 'Descripción',
    pt: 'Descrição'
  },
  STOREINTENT_FIELD_DESCRIPTION_PLACEHOLDER: {
    es: 'Descripción',
    pt: 'Descrição'
  },
  STOREINTENT_FIELD_THEME_LABEL: {
    es: 'Temática',
    pt: 'Tema'
  },
  STOREINTENT_FIELD_THEME_PLACEHOLDER: {
    es: 'Escribe aquí el nombre de la nueva temática',
    pt: 'Digite aqui o nome do novo tema'
  },
  STOREINTENT_FIELD_MINUTES_LABEL: {
    es: 'Minutos',
    pt: 'Minutos'
  },
  STOREINTENT_FIELD_MINUTES_PLACEHOLDER: {
    es: 'Minutos',
    pt: 'Minutos'
  },
  STOREINTENT_SAVE_BUTTON: {
    es: 'Guardar',
    pt: 'Salvar'
  },
  UPDATEINTENT_BREADCRUMB_CHATBOTS: {
    es: 'Chatbots',
    pt: 'Chatbots'
  },
  UPDATEINTENT_BREADCRUMB_INTENTS: {
    es: 'Intenciones',
    pt: 'Intenções'
  },
  UPDATEINTENT_EDIT_INTENT: {
    es: 'Editar intención',
    pt: 'Editar intenção'
  },
  UPDATEINTENT_FIELD_NAME_LABEL: {
    es: 'Nombre',
    pt: 'Nome'
  },
  UPDATEINTENT_FIELD_NAME_PLACEHOLDER: {
    es: 'Nombre de la intención',
    pt: 'Nome da intenção'
  },
  UPDATEINTENT_FIELD_DESCRIPTION_LABEL: {
    es: 'Descripción',
    pt: 'Descrição'
  },
  UPDATEINTENT_FIELD_DESCRIPTION_PLACEHOLDER: {
    es: 'Descripción',
    pt: 'Descrição'
  },
  UPDATEINTENT_FIELD_THEME_LABEL: {
    es: 'Temática',
    pt: 'Tema'
  },
  UPDATEINTENT_FIELD_THEME_PLACEHOLDER: {
    es: 'Escribe aquí el nombre de la nueva temática',
    pt: 'Digite aqui o nome do novo tema'
  },
  UPDATEINTENT_FIELD_MINUTES_LABEL: {
    es: 'Minutos',
    pt: 'Minutos'
  },
  UPDATEINTENT_FIELD_MINUTES_PLACEHOLDER: {
    es: 'Minutos',
    pt: 'Minutos'
  },
  UPDATEINTENT_SAVE_BUTTON: {
    es: 'Guardar',
    pt: 'Salvar'
  },
  BROADCASTMESSAGES_HEADER_SEND_MESSAGE_BROADCAST: {
    es: 'Envío de mensaje en Broadcast',
    pt: 'Envio de mensagem em Broadcast'
  },
  BROADCASTMESSAGES_TEMPLATE: {
    es: 'Plantilla:',
    pt: 'Modelo:'
  },
  BROADCASTMESSAGES_MESSAGE: {
    es: 'Mensaje:',
    pt: 'Mensagem:'
  },
  BROADCASTMESSAGES_MESSAGE_PLACEHOLDER: {
    es: 'Escribe aquí el texto del mensaje',
    pt: 'Digite aqui o texto da mensagem'
  },
  BROADCASTMESSAGES_BUTTON_EMOJI: {
    es: '😀',
    pt: '😀'
  },
  BROADCASTMESSAGES_BUTTON_MESSAGE_SEND_USERS_1: {
    es: '🚀 El mensaje se enviará a',
    pt: '🚀 A mensagem será enviada para'
  },
  BROADCASTMESSAGES_BUTTON_MESSAGE_SEND_USERS_2: {
    es: 'usuarios',
    pt: 'usuários'
  },
  BROADCASTMESSAGES_BUTTON_SEND_BROADCAST: {
    es: 'Enviar broadcast',
    pt: 'Enviar broadcast'
  },
  BROADCASTMESSAGES_CONFIRM_SEND_BROADCAST: {
    es: '¿Desea enviar el mensaje broadcast?',
    pt: 'Pretende enviar a mensagem de difusão?'
  },
  CONFIRM_ATTENTION: {
    es: 'Atención',
    pt: 'Atenção'
  },
  CONFIRMCOUNTDOWN_ATTENTION: {
    es: 'Atención',
    pt: 'Atenção'
  },
  CONFIRMCOUNTDOWN_SECONDS: {
    es: 'segundos',
    pt: 'segundos'
  },
  CONSULTREASON_REASON_INQUIRY: {
    es: '¿Cuál es el motivo de la consulta?',
    pt: 'Qual é o motivo da consulta?'
  },
  CONSULTREASON_SELECT_REASON_INQUIRY: {
    es: 'Selecciona el motivo de la consulta',
    pt: 'Selecione o motivo da consulta'
  },
  CONSULTREASON_INPUT_REASON_INQUIRY: {
    es: 'Nuevo motivo de consulta',
    pt: 'Novo motivo de consulta'
  },
  CONSULTREASON_TITLE_INQUIRY_PLACEHOLDER: {
    es: 'Título de la consulta',
    pt: 'Título da consulta'
  },
  CONSULTREASON_DESCRIPTION_INQUIRY_PLACEHOLDER: {
    es: 'Descripción de la consulta',
    pt: 'Descrição da consulta'
  },
  CONSULTREASON_BUTTON_ADD_REASON: {
    es: 'Añadir motivo',
    pt: 'Adicionar motivo'
  },
  CONSULTREASON_BUTTON_CANCEL: {
    es: 'Cancelar',
    pt: 'Cancelar'
  },
  CONSULTREASON_BUTTON_ACCEPT: {
    es: 'Aceptar',
    pt: 'Aceitar'
  },
  MODAL_ATTENTION: {
    es: 'Atención',
    pt: 'Atenção'
  },
  MODAL_ACCEPT: {
    es: 'Aceptar',
    pt: 'Aceitar'
  },
  UPDATEANSWERFILE_UPDATE_FILE: {
    es: 'Actualizar archivo',
    pt: 'Atualizar arquivo'
  },
  UPDATEANSWERFILE_SELECT_FILE: {
    es: 'Selecciona el archivo que deseas cargar',
    pt: 'Selecione o arquivo que deseja carregar'
  },
  UPDATEANSWERFILE_BUTTON_UPDATE: {
    es: 'Actualizar',
    pt: 'Atualizar'
  },
  UPLOADANSWERFILE_UPLOAD_NEW_FILE: {
    es: 'Cargar nuevo archivo',
    pt: 'Carregar novo arquivo'
  },
  UPLOADANSWERFILE_PAYLOAD_FILE_PLACEHOLDER: {
    es: 'Payload de este archivo',
    pt: 'Payload deste arquivo'
  },
  UPLOADANSWERFILE_SELECT_FILE: {
    es: 'Selecciona el archivo que deseas cargar',
    pt: 'Selecione o arquivo que deseja carregar'
  },
  UPLOADANSWERFILE_SAVE_FILE: {
    es: 'Guardar',
    pt: 'Salvar'
  },
  STORECLIENT_BREADCRUMB_CHATBOTS: {
    es: 'Chatbots',
    pt: 'Chatbots'
  },
  STORECLIENT_BREADCRUMB_NEW_CHATBOT: {
    es: 'Nuevo chatbot',
    pt: 'Novo chatbot'
  },
  STORECLIENT__NAME: {
    es: 'Nombre',
    pt: 'Nome'
  },
  STORECLIENT__NAME_PLACEHOLDER: {
    es: 'Nombre del Chatbot',
    pt: 'Nome do Chatbot'
  },
  STORECLIENT__DESCRIPTION: {
    es: 'Descripción',
    pt: 'Descrição'
  },
  STORECLIENT_DESCRIPTION_PLACEHOLDER: {
    es: 'Descripción',
    pt: 'Descrição'
  },
  STORECLIENT_BUTTON_SAVE: {
    es: 'Guardar',
    pt: 'Salvar'
  },
  UPDATECLIENT_BREADCRUMB_CHATBOTS: {
    es: 'Chatbots',
    pt: 'Chatbots'
  },
  UPDATECLIENT_BREADCRUMB_EDIT_CLIENT: {
    es: 'Editar Cliente',
    pt: 'Editar Cliente'
  },
  UPDATECLIENT_NAME: {
    es: 'Nombre',
    pt: 'Nome'
  },
  UPDATECLIENT_NAME_PLACEHOLDER: {
    es: 'Nombre del cliente',
    pt: 'Nome do cliente'
  },
  UPDATECLIENT_DESCRIPTION: {
    es: 'Descripción',
    pt: 'Descrição'
  },
  UPDATECLIENT_DESCRIPTION_PLACEHOLDER: {
    es: 'Descripción',
    pt: 'Descrição'
  },
  UPDATECLIENT_BUTTON_SAVE: {
    es: 'Guardar',
    pt: 'Salvar'
  },
  BROADCASTMESSAGES_CHATS_TITLE: {
    es: 'Broadcast:',
    pt: 'Broadcast:'
  },
  BROADCASTMESSAGES_CHATS_PLATFORM: {
    es: 'Plataforma:',
    pt: 'Plataforma:'
  },
  BROADCASTMESSAGES_CHATS_SELECT_PLATFORM: {
    es: '-Seleccione Plataforma-',
    pt: '-Selecione Plataforma-'
  },
  BROADCASTMESSAGES_CHATS_TEMPLATE: {
    es: 'Plantillas:',
    pt: 'Modelos:'
  },
  BROADCASTMESSAGES_CHATS_LAST_MESSAGE_USER: {
    es: 'Último mensaje con el usuario:',
    pt: 'Última mensagem com o usuário:'
  },
  BROADCASTMESSAGES_CHATS_OTHER_PARAMETERS: {
    es: 'Otros parámetros para segmentar el envío:',
    pt: 'Outros parâmetros para segmentar o envio:'
  },
  BROADCASTMESSAGES_CHATS_MESSAGE: {
    es: 'Mensaje:',
    pt: 'Mensagem:'
  },
  BROADCASTMESSAGES_CHATS_WRITE_MESSAGE: {
    es: 'Escribe aquí el texto del mensaje',
    pt: 'Digite aqui o texto da mensagem'
  },
  BROADCASTMESSAGES_CHATS_BUTTON_EMOJI: {
    es: '😀',
    pt: '😀'
  },
  BROADCASTMESSAGES_CHATS_SEND_MESSAGE_1: {
    es: '🚀 El mensaje en broadcast se enviará a',
    pt: '🚀 A mensagem em broadcast será enviada para'
  },
  BROADCASTMESSAGES_CHATS_SEND_MESSAGE_2: {
    es: 'usuarios',
    pt: 'usuários'
  },
  BROADCASTMESSAGES_CHATS_SEND_BROADCAST: {
    es: 'Enviar broadcast',
    pt: 'Enviar broadcast'
  },
  BROADCASTMESSAGES_CHATS_CONFIRM_SEND_BROADCAST: {
    es: '¿Desea enviar el mensaje broadcast?',
    pt: 'Pretende enviar a mensagem de difusão?'
  },
  CHAT_INTENT: {
    es: 'Intención:',
    pt: 'Intenção:'
  },
  CHAT_PHRASE: {
    es: 'Frase:',
    pt: 'Frase:'
  },
  CHAT_NEW_MESSAGES: {
    es: 'Tiene nuevos mensajes sin leer',
    pt: 'Existem novas mensagens não lidas'
  },
  CHAT_ENTER_LABEL: {
    es: 'Enter = Enviar',
    pt: 'Enter = Enviar'
  },
  CHATINFO_TITLE_CHATBOT: {
    es: 'Chatbot',
    pt: 'Chatbot'
  },
  CHATINFO_TITLE_PLATFORM: {
    es: 'Plataforma',
    pt: 'Plataforma'
  },
  CHATINFO_TITLE_FIRST_MESSAGE: {
    es: 'Primer mensaje:',
    pt: 'Primeira mensagem:'
  },
  CHATINFO_TITLE_LAST_MESSAGE: {
    es: 'Último mensaje:',
    pt: 'Última mensagem:'
  },
  CHATINFO_TITLE_EXPERIENCE_1: {
    es: 'Experiencia (',
    pt: 'Experiência ('
  },
  CHATINFO_TITLE_EXPERIENCE_2: {
    es: ' mensajes):',
    pt: ' mensagens):'
  },
  CHATINFO_EXPERIENCE_GOOD: {
    es: 'Bien: ',
    pt: 'Bom: '
  },
  CHATINFO_EXPERIENCE_WRONG: {
    es: 'Mal: ',
    pt: 'Errado: '
  },
  CHATINFO_EXPERIENCE_DOUBT: {
    es: 'Duda: ',
    pt: 'Dúvida: '
  },
  CHATINFO_AGENT_INTERVENTION: {
    es: 'Intervención de agente:',
    pt: 'Intervenção do agente:'
  },
  CHATINFO_AGENT_LAST_AGENT: {
    es: 'Último agente:',
    pt: 'Último agente:'
  },
  CHATINFO_AGENT_ACTIVE_NOW: {
    es: 'Activo ahora:',
    pt: 'Ativo agora:'
  },
  CHATINFO_BUTTON_TAKE_CONTROL: {
    es: 'Tomar el control',
    pt: 'Assumir o controle'
  },
  CHATINFO_BUTTON_SOLVED: {
    es: 'Marcar como resuelta',
    pt: 'Marcar como resolvido'
  },
  CHATINFO_CONFIRM_TAKE_CONVERSATION: {
    es: '¿Desea tomar el control de esta conversación?',
    pt: 'Quer assumir o controlo desta conversa?'
  },
  CHATINFO_CONFIRM_RESOLVE_CONVERSATION: {
    es: '¿Desea marcar esta conversación como resuelta?',
    pt: 'Deseja marcar esta conversa como resolvida?'
  },
  CHATINFO_CONVERSATION_TAKEN_MODAL: {
    es: 'Esta conversación ya ha sido tomada por el agente:',
    pt: 'Esta conversa já foi retomada pelo agente:'
  },
  CHATSELECTOR_BOT: {
    es: 'Bot',
    pt: 'Bot'
  },
  CHATSELECTOR_AGENT: {
    es: 'Agente',
    pt: 'Agente'
  },
  CHATSELECTOR_INPUT_NAME_FILTER: {
    es: 'Filtrar por nombre. ESC para cancelar',
    pt: 'Filtrar por nome. ESC para cancelar'
  },
  CHATSELECTOR_VIEW_MORE: {
    es: 'Ver más',
    pt: 'Ver mais'
  },
  CHATSELECTOR_BUTTON_SEND_BROADCAST: {
    es: 'Enviar Broadcast',
    pt: 'Enviar Broadcast'
  },
  ANALYTICS_BREADCRUMB: {
    es: 'Métricas',
    pt: 'Análiticas'
  },
  ANALYTICS_LOADING: {
    es: 'Cargando...',
    pt: 'Carregando...'
  },
  ANALYTICS_TOTAL: {
    es: 'Total',
    pt: 'Carregando...'
  },
  ANALYTICS_LAST_YEAR: {
    es: 'Último año',
    pt: 'Último ano'
  },
  ANALYTICS_THIS_YEAR: {
    es: 'Este año',
    pt: 'Este ano'
  },
  ANALYTICS_LAST_MONTH: {
    es: 'Último mes',
    pt: 'Último mês'
  },
  ANALYTICS_THIS_MONTH: {
    es: 'Este mes',
    pt: 'Este mês'
  },
  ANALYTICS_LAST_7_DAYS: {
    es: 'Últimos 7 días',
    pt: 'Últimos 7 dias'
  },
  ANALYTICS_TODAY: {
    es: 'Hoy',
    pt: 'Hoje'
  },
  ANALYTICS_ALL_CLIENTS: {
    es: 'Todos',
    pt: 'Todos'
  },
  ANALYTICSINTENTSTABLE_TITLE_MORE_FREQUENTS_TYPE1: {
    es: 'Las más frecuentes',
    pt: 'Os mais frequentes'
  },
  ANALYTICSINTENTSTABLE_MORE_FREQUENTS_INTENT_TYPE1: {
    es: 'Intención',
    pt: 'Intenção'
  },
  'ANALYTICSINTENTSTABLE_MORE_FREQUENTS_TYPE1_#': {
    es: '#',
    pt: '#'
  },
  ANALYTICSINTENTSTABLE_MORE_FREQUENTS_TYPE1_GOOD: {
    es: '👍',
    pt: '👍'
  },
  ANALYTICSINTENTSTABLE_MORE_FREQUENTS_TYPE1_BAD: {
    es: '👎',
    pt: '👎'
  },
  ANALYTICSINTENTSTABLE_MORE_FREQUENTS_TYPE1_RIGHT: {
    es: 'Bien👌',
    pt: 'Bem👌'
  },
  ANALYTICSINTENTSTABLE_MORE_FREQUENTS_TYPE1_DOUBT: {
    es: 'Duda🤔',
    pt: 'Dúvida🤔'
  },
  ANALYTICSINTENTSTABLE_TYPE1_NO_DATA: {
    es: 'Sin Datos',
    pt: 'Sem dados'
  },
  ANALYTICSINTENTSTABLE_TYPE2_NEED_REVISION: {
    es: 'Necesitan revisión (feedback del usuario)',
    pt: 'Precisam de revisão (feedback do usuário)'
  },
  ANALYTICSINTENTSTABLE_INTENT_TYPE2: {
    es: 'Intención',
    pt: 'Intenção'
  },
  'ANALYTICSINTENTSTABLE_NEED_REVISION_TYPE2_#': {
    es: '#',
    pt: '#'
  },
  ANALYTICSINTENTSTABLE_NEED_REVISION_TYPE2_GOOD: {
    es: '👍',
    pt: '👍'
  },
  ANALYTICSINTENTSTABLE_NEED_REVISION_TYPE2_BAD: {
    es: '👎',
    pt: '👎'
  },
  ANALYTICSINTENTSTABLE_NEED_REVISION_TYPE2_KO: {
    es: 'KO❌',
    pt: 'KO❌'
  },
  ANALYTICSINTENTSTABLE_TYPE2_NO_DATA: {
    es: 'Sin Datos',
    pt: 'Sem dados'
  },
  CHARTS_TITLE_MORE_FREQUENTS: {
    es: 'Las más frecuentes',
    pt: 'Os mais frequentes'
  },
  CHARTS_TITLE_MORE_FREQUENTS_VIEW_ALL: {
    es: '(Ver todas)',
    pt: '(Ver todos)'
  },
  CHARTS_INTENTS_FREQUENTS_INTENT: {
    es: 'Intención',
    pt: 'Intenção'
  },
  'CHARTS_INTENTS_FREQUENTS_#': {
    es: '#',
    pt: '#'
  },
  CHARTS_INTENTS_FREQUENTS_RIGHT: {
    es: 'Bien👌',
    pt: 'Bem👌'
  },
  CHARTS_INTENTS_FREQUENTS_DOUBT: {
    es: 'Duda🤔',
    pt: 'Dúvida🤔'
  },
  CHARTS_INTENTS_FREQUENTS_NO_DATA: {
    es: 'Sin Datos',
    pt: 'Sem dados'
  },
  CHARTS_INTENTS_FREQUENTS_NEED_REVISION: {
    es: 'Necesitan revisión (feedback del usuario)',
    pt: 'Precisam de revisão (feedback do usuário)'
  },
  CHARTS_INTENTS_FREQUENTS_NEED_REVISION_VIEW_ALL: {
    es: '(Ver todas)',
    pt: '(Ver todos)'
  },
  CHARTS_INTENT_TYPE2: {
    es: 'Intención',
    pt: 'Intenção'
  },
  'CHARTS_NEED_REVISION_TYPE2_#': {
    es: '#',
    pt: '#'
  },
  CHARTS_NEED_REVISION_TYPE2_GOOD: {
    es: '👍',
    pt: '👍'
  },
  CHARTS_NEED_REVISION_TYPE2_BAD: {
    es: '👎',
    pt: '👎'
  },
  CHARTS_NEED_REVISION_TYPE2_KO: {
    es: 'KO❌',
    pt: 'KO❌'
  },
  CHARTS_TYPE2_NO_DATA: {
    es: 'Sin Datos',
    pt: 'Sem dados'
  },
  CHARTS_HEADER_TITLE_EVOLUTION_MESSAGES: {
    es: 'Evolución de Mensajes y tasa de éxito',
    pt: 'Evolução de Mensagens e taxa de sucesso'
  },
  CHARTS_HEADER_EVOLUTION_MESSAGES: {
    es: 'Mensajes',
    pt: 'Mensagens'
  },
  CHARTS_HEADER_EVOLUTION_SUCCESS: {
    es: 'Tasa de éxito',
    pt: 'Taxa de sucesso'
  },
  CHARTS_EVOLUTION_NO_DATA_NO_DISCARDED_MESSAGES: {
    es: 'Sin Datos',
    pt: 'Sem dados'
  },
  CHARTS_EVOLUTION_NO_DATA_WITH_DISCARDED_MESSAGES: {
    es: 'Sin Datos',
    pt: 'Sem dados'
  },
  CHARTS_EVOLUTION_NO_DATA_TOTAL_EVOLUTION: {
    es: 'Sin Datos',
    pt: 'Sem dados'
  },
  CHARTS_MINUTES_SAVED: {
    es: 'Minutos ahorrados en conversaciones automáticas',
    pt: 'Minutos economizados em conversas automáticas'
  },
  CHARTS_AGENTS_INTERVENTIONS: {
    es: 'Intervenciones de agentes',
    pt: 'Intervenções de agentes'
  },
  CHARTS_TOTAL_AGENTS_MESSAGES: {
    es: 'Mensajes totales de agentes',
    pt: 'Mensagens totais de agentes'
  },
  CHARTS_POINTER_VIEW_KPI: {
    es: '(ver KPI de agentes)',
    pt: '(ver KPI de agentes)'
  },
  CHARTS_TITLE_MESSAGES_BY_PLATFORM: {
    es: 'Mensajes por plataforma',
    pt: 'Mensagens por plataforma'
  },
  CHARTS_MESSAGES_BY_PLATFORM_NO_DATA: {
    es: 'Sin Datos',
    pt: 'Sem dados'
  },
  INTENTSPHRASESTABLE_PHRASE: {
    es: 'Frase',
    pt: 'Frase'
  },
  'INTENTSPHRASESTABLE_PHRASE_#': {
    es: '#',
    pt: '#'
  },
  'INTENTSPHRASESTABLE_PHRASE_%': {
    es: '%',
    pt: '%'
  },
  KPIAGENTS_TITLE_KPI_AGENTS: {
    es: 'KPIs de Agentes - ',
    pt: 'KPIs de Agentes - '
  },
  KPIAGENTS_FILTER_INTERVENTIONS: {
    es: 'intervenciones',
    pt: 'intervenções'
  },
  KPIAGENTS_FILTER_MESSAGES: {
    es: 'mensajes',
    pt: 'mensagens'
  },
  KPIAGENTS_VALUE_OK: {
    es: 'valoradas OK 👍',
    pt: 'avaliadas OK 👍'
  },
  KPIAGENTS_FILTER_TABLE_TITLE_INTERVENTIONS: {
    es: 'Intervenciones',
    pt: 'Intervenções'
  },
  KPIAGENTS_FILTER_TABLE_TITLE_AGENT: {
    es: 'Agente',
    pt: 'Agente'
  },
  KPIAGENTS_FILTER_TABLE_TITLE_VALUE: {
    es: 'Valoración',
    pt: 'Avaliação'
  },
  KPIAGENTS_TABLE_DATE: {
    es: 'Fecha',
    pt: 'Data'
  },
  KPIAGENTS_TABLE_AGENT: {
    es: 'Agente',
    pt: 'Agente'
  },
  KPIAGENTS_TABLE_VALUE: {
    es: 'Valoración',
    pt: 'Avaliação'
  },
  KPIAGENTS_TABLE_USER: {
    es: 'Usuario',
    pt: 'Usuário'
  },
  KPIAGENTS_INQUIRES_MADE: {
    es: 'Consultas realizadas',
    pt: 'Consultas realizadas'
  },
  KPIAGENTS_INQUIRES_MADE_ORDER_BY: {
    es: 'Ordenar por',
    pt: 'Ordenar por'
  },
  KPIAGENTS_INQUIRES_MADE_SELECT: {
    es: '- Seleccione -',
    pt: '- Selecione -'
  },
  'KPIAGENTS_INQUIRES_MADE_SELECT_#': {
    es: '#',
    pt: '#'
  },
  KPIAGENTS_INQUIRES_MADE_SELECT_OK: {
    es: 'OK',
    pt: 'OK'
  },
  KPIAGENTS_INQUIRES_MADE_SELECT_KO: {
    es: 'KO',
    pt: 'KO'
  },
  KPIAGENTS_TABLE_INQUIRE: {
    es: 'Consulta',
    pt: 'Consulta'
  },
  KPIAGENTS_TABLE_DESCRIPTION: {
    es: 'Descripción',
    pt: 'Descrição'
  },
  'KPIAGENTS_TABLE_#': {
    es: '#',
    pt: '#'
  },
  KPIAGENTS_TABLE_OK: {
    es: '% OK👍',
    pt: '% OK👍'
  },
  KPIAGENTS_TABLE_KO: {
    es: '% KO👎',
    pt: '% KO👎'
  },
  KPIAGENTS_AGENTS_RATING: {
    es: 'Valoraciones de los Agentes',
    pt: 'Avaliações dos Agentes'
  },
  KPIAGENTS_AGENTS_RATING_ORDER: {
    es: 'Ordenar por',
    pt: 'Ordenar por'
  },
  KPIAGENTS_AGENTS_RATING_SELECT: {
    es: '- Seleccione -',
    pt: '- Selecione -'
  },
  KPIAGENTS_AGENTS_RATING_OK: {
    es: 'OK',
    pt: 'OK'
  },
  KPIAGENTS_AGENTS_RATING_KO: {
    es: 'KO',
    pt: 'KO'
  },
  'KPIAGENTS_AGENTS_RATING_#': {
    es: '#',
    pt: '#'
  },
  KPIAGENTS_AGENTS_RATING_AGENT: {
    es: 'Agente',
    pt: 'Agente'
  },
  KPIAGENTS_AGENTS_RATING_OPTION_AGENT: {
    es: 'Agente',
    pt: 'Agente'
  },
  KPIAGENTS_AGENTS_RATING_OPTION_INTERVENTIONS: {
    es: '# Intervenciones',
    pt: '# Intervenções'
  },
  KPIAGENTS_AGENTS_RATING_OPTION_OK: {
    es: 'OK👍',
    pt: 'OK👍'
  },
  KPIAGENTS_AGENTS_RATING_OPTION_KO: {
    es: 'KO👎',
    pt: 'KO👎'
  },
  KPIAGENTS_AGENTS_RATING_LOADING: {
    es: 'Cargando...',
    pt: 'Carregando...'
  },
  STATISTICS_INFO_NUMBER_INTENTS: {
    es: 'Número de intenciones y frases creadas en el sistema en el periodo seleccionado y variación respecto al total.',
    pt: 'Número de intenções e frases criadas no sistema no período selecionado e variação em relação ao total.'
  },
  STATISTICS_LEGEND_INTENTS: {
    es: 'Intenciones',
    pt: 'Intenções'
  },
  STATISTICS_LEGEND_NEW_PHRASES: {
    es: 'Nuevas frases',
    pt: 'Novas frases'
  },
  STATISTICS_INFO_MESSAGES_CONVERSATIONS_TRAFFIC: {
    es: 'Tráfico de mensajes y conversaciones entre usuario y bot en el periodo seleccionado y variación respecto al anterior periodo.',
    pt: 'Tráfego de mensagens e conversas entre usuário e bot no período selecionado e variação em relação ao período anterior.'
  },
  STATISTICS_LEGEND_MESSAGES: {
    es: 'Mensajes',
    pt: 'Mensagens'
  },
  STATISTICS_LEGEND_CONVERSATIONS: {
    es: 'Conversaciones',
    pt: 'Conversas'
  },
  STATISTICS_INFO_SUCCESS_RATE: {
    es: 'Tasa de éxito en el entendimiento del bot y de feedback del usuario, variación respecto a la media:',
    pt: 'Taxa de sucesso na compreensão do bot e no feedback do usuário, variação em relação à média:'
  },
  STATISTICS_SUCCESS_RATE_ERROR: {
    es: '❌ Error (no entendidos)',
    pt: '❌ Erro (não compreendidos)'
  },
  STATISTICS_SUCCESS_RATE_DOUBT: {
    es: '🤨 Duda (entendidos parcialmente)',
    pt: '🤨 Dúvida (compreendidos parcialmente)'
  },
  STATISTICS_SUCCESS_RATE_RIGHT: {
    es: '👌 Bien (entendidos correctamente) por parte del bot.',
    pt: '👌 Correto (compreendidos corretamente) pelo bot.'
  },
  STATISTICS_SUCCESS_RATE_POSITIVE_FEEDBACK: {
    es: '👍 Feedback positivo recibido por el usuario.',
    pt: '👍 Feedback positivo recebido pelo usuário.'
  },
  STATISTICS_SUCCESS_LEGEND_ERROR_EMOJI: {
    es: '❌',
    pt: '❌'
  },
  STATISTICS_SUCCESS_LEGEND_ERROR: {
    es: 'Error',
    pt: 'Erro'
  },
  STATISTICS_SUCCESS_LEGEND_DOUBT_EMOJI: {
    es: '🤔',
    pt: '🤔'
  },
  STATISTICS_SUCCESS_LEGEND_DOUBT: {
    es: 'Duda',
    pt: 'Dúvida'
  },
  STATISTICS_SUCCESS_LEGEND_RIGHT_EMOJI: {
    es: '👌',
    pt: '👌'
  },
  STATISTICS_SUCCESS_LEGEND_RIGHT: {
    es: 'Bien',
    pt: 'Correto'
  },
  STATISTICS_SUCCESS_LEGEND_OK_EMOJI: {
    es: '👍',
    pt: '👍'
  },
  STATISTICS_SUCCESS_LEGEND_OK: {
    es: 'Ok',
    pt: 'Ok'
  },
  STATISTICS_INFO_RATE_MESSAGES_TRAINED: {
    es: 'Tasa de mensajes entrenados en el periodo y tasa global de mensajes pendientes de entrenar.',
    pt: 'Taxa de mensagens treinadas no período e taxa global de mensagens pendentes de treinamento.'
  },
  STATISTICS_INFO_MESSAGES_TRAINED_LEGEND: {
    es: 'Mensajes entrenados',
    pt: 'Mensagens treinadas'
  },
  STATISTICS_INFO_MESSAGES_TRAINED_LEGEND_FROM_TOTAL: {
    es: 'Del total pendientes de entrenar',
    pt: 'Do total pendentes de treinamento'
  },

  __nomenclatura__: 'NOMBREFICHERO_DETALLES'
}

export default {
  copies
}



// WEBPACK FOOTER //
// ./src/copies.js